import React, { Component, ReactNode } from 'react';
import { KompisAccordion, KompisAccordionItem } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { localeService } from '../../../services';
import CoverProductDescriptionContent from '../CoverProductDescriptionContent/CoverProductDescriptionContent';
import styled from 'styled-components';

type Props = {
	productDescriptionOpen: boolean;
	onExpand?: () => void;
};

const AccordionItemWrapper = styled.div`
	padding: 0 24px 24px;
`;

/**
 * React component.
 *
 */
export default class CoverProductDescriptionLightbox extends Component<Props> {
	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		const { props } = this;
		const { onExpand } = props;

		return (
			<KompisAccordion
				theme={SkapaTheme}
				// @ts-expect-error Kompis elemenets support style but it isn't exposed
				style={{ marginTop: '16px' }}
			>
				<KompisAccordionItem
					expanded={props.productDescriptionOpen}
					theme={SkapaTheme}
					label={localeService.getTranslation('coverPickerCoverDescription')}
					onExpand={(): void => onExpand && onExpand()}
				>
					<AccordionItemWrapper>
						<CoverProductDescriptionContent />
					</AccordionItemWrapper>
				</KompisAccordionItem>
			</KompisAccordion>
		);
	}
}
